<template>
  <div>
    <div class="card mb-4">
      <h5 class="card-header">Attachments</h5>
      <div class="card-body">
        <AttachmentsList
          ref="attachmentsList"
          :entity-id="leadQuoteOrder.id"
          selectable
          @update:selectedAttachments="onSelectionChange"
        />
      </div>
    </div>

    <div v-if="selectedAttachmentIds.length > 0" class="card mb-4">
      <h5 class="card-header">
        Email {{ selectedAttachmentIds.length }} selected attachment{{ selectedAttachmentIds.length > 1 ? 's' : '' }}
      </h5>
      <div class="card-body">
        <b-form-group label="Send to:">
          <b-form-radio-group v-model="recipientType" buttons button-variant="outline-primary" size="sm">
            <b-form-radio value="client" :disabled="!customerEmail">
              Client{{ customerEmail ? ': ' + customerEmail : ' (no email)' }}
            </b-form-radio>
            <b-form-radio value="carrier" :disabled="!carrierEmail">
              Carrier{{ carrierEmail ? ': ' + carrierEmail : ' (no email)' }}
            </b-form-radio>
            <b-form-radio value="custom">Custom</b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group v-if="recipientType === 'custom'" label="Email address:">
          <b-form-input v-model="customEmail" type="email" placeholder="Enter email address" />
        </b-form-group>

        <b-form-group label="Subject:">
          <b-form-input v-model="emailSubject" placeholder="Attachments" />
        </b-form-group>

        <b-form-group label="Message (optional):">
          <b-form-textarea v-model="emailBody" rows="3" placeholder="Optional message..." />
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-btn variant="primary" :disabled="!canSend || sending" @click="sendEmail">
            <span v-if="sending" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            {{ sending ? 'Sending...' : 'Send Email' }}
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentsList from '@/components/shared/AttachmentsList';
import { ApiClient } from '@/api/ApiClient';

export default {
  name: 'OrderAttachments',
  components: {
    AttachmentsList,
  },
  props: {
    leadQuoteOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedAttachmentIds: [],
      recipientType: null,
      customEmail: '',
      emailSubject: '',
      emailBody: '',
      sending: false,
    };
  },
  computed: {
    customerEmail() {
      return this.leadQuoteOrder?.customer?.contact?.email || '';
    },
    carrierEmail() {
      return this.leadQuoteOrder?.carrier?.contact?.email || '';
    },
    resolvedToAddress() {
      if (this.recipientType === 'client') return this.customerEmail;
      if (this.recipientType === 'carrier') return this.carrierEmail;
      if (this.recipientType === 'custom') return this.customEmail;
      return '';
    },
    canSend() {
      return this.selectedAttachmentIds.length > 0 && this.recipientType && this.resolvedToAddress;
    },
  },
  methods: {
    onSelectionChange(ids) {
      this.selectedAttachmentIds = ids;
    },
    async sendEmail() {
      this.sending = true;
      const response = await ApiClient.emails.post({
        body: {
          leadId: this.leadQuoteOrder.id,
          toAddress: this.resolvedToAddress,
          subject: this.emailSubject || `Attachments from order #${this.leadQuoteOrder.id}`,
          contentPlain: this.emailBody,
          leadAttachment: this.selectedAttachmentIds,
        },
      });
      this.sending = false;
      if (response.status === 200) {
        this.$refs.attachmentsList.selectedAttachments = [];
        this.selectedAttachmentIds = [];
        this.recipientType = null;
        this.customEmail = '';
        this.emailSubject = '';
        this.emailBody = '';
      }
    },
  },
};
</script>
